import React from 'react';
import type { PageType } from '@/features/Analytics';
import { TimeSlotsClient } from './index';
import type { IBookingDoctorData } from '@/entities/booking/model/types';
interface Props {
  bookingData: IBookingDoctorData[];
  doctorId: number;
  pageType: PageType;
}
export const TimeSlotsServer: React.FC<Props> = ({
  bookingData,
  doctorId,
  pageType
}) => {
  const schedule = bookingData.length && bookingData[0].onlineBooking.schedule ? bookingData[0].onlineBooking.schedule : [];
  const firstWorkingDay = schedule.length ? schedule.find(day => day.isWork && day.timeslots) || schedule[0] : null;
  return <TimeSlotsClient doctorId={doctorId} bookingData={bookingData} initialDay={firstWorkingDay} pageType={pageType} data-sentry-element="TimeSlotsClient" data-sentry-component="TimeSlotsServer" data-sentry-source-file="TimeSlotsServer.tsx" />;
};